import {finitePrice, validPrice, priceLoadReason} from './orderMenuCache';

const invalid = label => `${label}: Preis fehlt oder ist ungültig. Bitte den Admin unter Menü & Preise prüfen lassen.`;
const pending = 'Preise werden noch geladen.';
const idOf = item => item.topping_type || item.id;

export function orderPriceAvailability(menu, config, draft, activeCategory, order, customItems, nightOnly = false) {
  const issues = {};
  const resources = {};
  const add = (key, label, kinds, valid = true) => {
    resources[key] = kinds;
    const error = kinds.map(kind => menu[kind]?.error).find(Boolean);
    const missing = kinds.some(kind => !menu[kind]?.data);
    if (error) issues[key] = `${label}: ${priceLoadReason(error)}`;
    else if (missing) issues[key] = `${label}: ${pending}`;
    else if (!valid) issues[key] = invalid(label);
  };
  add('config', 'Wachabteilung', ['config']);
  const rolls = menu.display.rolls || [];
  const toppings = menu.display.toppings || [];
  const settings = menu.display.extras || {};
  const visibility = config?.breakfast_item_visibility || {};
  const selected = new Set(['config']);
  if (activeCategory === 'breakfast') {
    if (!nightOnly) {
      for (const type of config?.available_roll_types || ['weiss', 'koerner']) {
        add(type, type === 'weiss' ? 'Helle Brötchen' : 'Körnerbrötchen', ['rolls', 'toppings'],
          validPrice(rolls.find(item => item.roll_type === type)?.price));
        if (!issues[type] && !toppings.some(item => finitePrice(item.price))) issues[type] = 'Brötchen: Es sind keine Beläge mit gültigem Preis vorhanden. Bitte den Admin unter Menü & Preise prüfen lassen.';
      }
      for (const [key, label] of Object.entries({boiled_eggs: 'Gekochte Eier', fried_eggs: 'Spiegeleier', scrambled_eggs: 'Rührei', coffee: 'Kaffee'})) {
        if (visibility[key] !== false) add(key, settings[`${key}_name`] || label, ['extras'], validPrice(settings[`${key}_price`]));
      }
      for (const item of toppings) {
        if (!finitePrice(item.price)) issues[`topping:${idOf(item)}`] = invalid(item.name || 'Belag');
      }
    }
    if (!nightOnly || draft?.has_lunch) add('lunch', 'Mittagessen', ['lunch', 'lunchVariants']);
    if (config?.meal_types?.dinner?.enabled !== false || draft?.has_dinner) add('dinner', 'Abendessen', ['dinner', 'dinnerVariants']);
    if (draft?.white_halves > 0) selected.add('weiss');
    if (draft?.seeded_halves > 0) selected.add('koerner');
    for (const key of ['boiled_eggs', 'fried_eggs', 'scrambled_eggs']) if (draft?.[key] > 0) selected.add(key);
    if (draft?.has_coffee) selected.add('coffee');
    if (draft?.has_lunch) selected.add('lunch');
    if (draft?.has_dinner) selected.add('dinner');
    for (const id of draft?.toppings || []) {
      if (id) {
        const key = `topping:${id}`;
        selected.add(key); resources[key] = ['toppings'];
        if (!toppings.some(item => idOf(item) === id && finitePrice(item.price))) issues[key] = invalid(toppings.find(item => idOf(item) === id)?.name || 'Gewählter Belag');
      }
    }
    // Existing selections must never bypass validation because an item was hidden meanwhile.
    for (const key of selected) {
      if (!resources[key] && !key.startsWith('topping:')) {
        resources[key] = ['extras']; issues[key] = 'Ein gewähltes Angebot ist nicht mehr verfügbar. Bitte die Auswahl prüfen.';
      }
    }
  } else {
    add('categories', 'Getränke & Snacks', ['categories']);
    selected.add('categories');
    const category = menu.display.categories?.find(item => item.id === activeCategory || item.system_key === activeCategory);
    if (category) {
      const quantities = category.system_key === 'drinks' ? order.drink_items : category.system_key === 'snacks' ? order.sweet_items : customItems[category.id] || {};
      const products = Array.isArray(category.products) ? category.products.filter(item => item && typeof item === 'object') : [];
      if (!Array.isArray(category.products) || products.length !== category.products.length) issues.categories = invalid(category.name);
      for (const item of products) if (!validPrice(item.price)) issues[`product:${item.id}`] = invalid(item.name);
      for (const [id, count] of Object.entries(quantities)) {
        if (count > 0) {
          const key = `product:${id}`; selected.add(key); resources[key] = ['categories'];
          if (!products.some(item => item.id === id && validPrice(item.price))) issues[key] = invalid(products.find(item => item.id === id)?.name || 'Gewählter Artikel');
          const product = products.find(item => item.id === id);
          if (!issues[key] && product?.stock_enabled && product.stock_quantity < count) {
            issues[key] = `${product.name || 'Gewählter Artikel'}: Nur noch ${Math.max(0, product.stock_quantity)} verfügbar. Bitte die Auswahl anpassen.`;
          }
        }
      }
    }
  }
  return {
    issues,
    blocked: [...selected].some(key => issues[key]),
    required: [...new Set([...selected].flatMap(key => resources[key] || []))],
    retry: [...new Set(Object.keys(issues).flatMap(key => resources[key] || (key.startsWith('topping:') ? ['toppings'] : ['categories'])))],
  };
}
